module.exports = __webpack_public_path__ + "static/media/result_as_ja.8988a1e4.jpg";